<template>
  <div class="project-create modal">
    <div class="c-form">
      <header>
        <h1>Create new project</h1>

        <button class="close" @click="closeModal">
          <IconClose/>
        </button>
      </header>

      <p>Start by selecting a layout or creating new.</p>
      <div class="form-group">
        <span>Project name</span>
        <input
          type="text"
          placeholder="Name"
          name="title"
          class="c-input"
          required
          v-model="title"
        />
      </div>
      <!--<div class="form-group">
        <span>Width (px)</span>
        <input
          type="text"
          placeholder="Width"
          name="width"
          class="c-input"
          required
          v-model="width"
        />
      </div>-->
      <div class="">
        <span>Templates</span>

        <div class="cards">
          <label for="blankProject" class="card">
            <div class="content">
              <img src="/assets/blankProject.jpg">
            </div>
            <div class="title"><input type="radio" id="blankProject" name="projectTemplate" v-model="content" value="blankProject" checked> Blank project</div>
          </label>
          <label for="exampleProject" class="card">
            <div class="content">
              <img src="/assets/exampleProject.jpg">
            </div>
            <div class="title"><input type="radio" id="exampleProject" name="projectTemplate" v-model="content" value="exampleProject"> Example project</div>
          </label>
        </div>
      </div>
      <div class="form-group -submit">
        <button class="c-button" @click="createProject">
          Create
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from './../Icons/Close.vue'

export default {
  name: "Create",
  data() {
    return {
      title: "Blank project",
      width: 600,
      content: []
    };
  },
  components: {
    IconClose
  },
  created() {
    this.defaults = {
      blankProject: [],
      exampleProject: [{"_uid":"58746c8c-9e35-46a5-8648-718f472b68fe","name":"Hero image","component":"Figure","icon":"IconImage","settings":{"style":"","url":"assets/hero.png","align":"center"}},{"_uid":"c4dfad39-4961-4e07-9609-9d7d6887bc40","name":"Space","icon":"IconSpace","component":"Space","settings":{"height":"20"}},{"_uid":"79db6afd-297d-43d6-a57e-d2a88f18cb1b","name":"Title","icon":"IconParagraph","component":"Paragraph","settings":{"style":"","content":"Welcome to Neus!","fontColor":"#000000","align":"center","fontSize":42,"fontWeight":900}},{"_uid":"51326473-6783-49e7-8dde-2d1fe5e66300","name":"Subtitle","icon":"IconParagraph","component":"Paragraph","settings":{"style":"","content":"A new way to create newsletters.","fontColor":"#000000","align":"center","fontSize":22,"fontWeight":200}},{"_uid":"69f48099-e2a4-44bc-8021-17e861159186","name":"Space","icon":"IconSpace","component":"Space","settings":{"height":"20"}},{"_uid":"a8387236-f0ec-4272-8b89-41d667c720ec","name":"Space","icon":"IconSpace","component":"Space","settings":{"height":9}},{"_uid":"00de0f77-34cc-490f-b729-7a1a1a5c93e7","name":"List title","icon":"IconParagraph","component":"Paragraph","settings":{"style":"","content":"It's simple to do complicated things.","fontColor":"#000000","align":"center","fontSize":"24","fontWeight":200}},{"_uid":"e3f79e7e-599a-4506-905d-9868de804133","name":"List item","icon":"IconList","component":"ListItem","settings":{"style":"","content":"Use many tools from the Tool box to easily create mail structure.","align":"center","fontSize":"16"}},{"_uid":"ddea3df0-f2e6-4c2b-bfb8-2ec4113c1a58","name":"List item","icon":"IconList","component":"ListItem","settings":{"style":"","content":"Test the mobile view using the Mobile button.","align":"center","fontSize":"16"}},{"_uid":"74611ee2-5918-44c2-aaf5-0866894377f8","name":"List item","icon":"IconList","component":"ListItem","settings":{"style":"","content":"Save and load your projects.","align":"center","fontSize":"16"}},{"_uid":"d07ee142-2d9c-499f-a5be-1446c20a90b1","name":"Space","component":"Space","icon":"IconSpace","settings":{"height":30}},{"_uid":"16df0f08-4fe3-45d5-ad85-ff8bc6e1e6a8","name":"CTA Button","component":"Button","icon":"IconButton","settings":{"style":"","content":"It's only a click away.","align":"center","fontSize":18,"backgroundColor":"#3D51FA","fontColor":"#ffffff","padding":14,"link":""}},{"_uid":"87a01ebe-dbcf-481e-992b-df667ef52197","name":"Space","icon":"IconSpace","component":"Space","settings":{"height":60}},{"_uid":"f3ce7b4d-b117-4d86-87f8-7f00f319c3d5","name":"Separator","icon":"IconDivision","component":"Separator","settings":{}},{"_uid":"a1682d05-9eef-4ffc-ba70-2affc2076610","name":"Footer text","icon":"IconParagraph","component":"Paragraph","settings":{"style":"","content":"Created by Lakeman","fontColor":"#000000","align":"center","fontSize":16,"fontWeight":400}},{"_uid":"ab7a6f99-ab2b-4edc-a685-345ec2fc47ce","name":"Footer text (Copy)","icon":"IconParagraph","component":"Paragraph","settings":{"style":"","content":"2020","fontColor":"#000000","align":"center","fontSize":16,"fontWeight":200}}]
    }
  },
  methods: {
    createProject: function () {
      if(typeof this.defaults[this.content] == "undefined") {
        this.defaults[this.content] = [];
      }
      this.$emit("createdProject", this.title, this.width, this.defaults[this.content]);
      this.title = "";
      this.width = 600;
    },
    closeModal: function () {
      this.$emit("closedModal");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
label{
  cursor: pointer;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  h1 {
    margin: 0;
  }

  .close {
    width: 40px;
    height: 40px;
    margin: 0;
    svg {
      width: 40px;
      height: 40px;
    }
  }
}
.modal {
  color: #fff;
  .c-form {
    min-width: 600px;
  }
}
.form-group {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  input {
    background: transparent;
    border: 1px solid gray;
    color: #fff;
    padding: 6px 10px;
    border-radius: 5px;
  }
}
.c-button {
  background: #3d50fa;
  color: #fff;
  padding: 12px 20px;
  border: 0;
  border-radius: 12px;
  box-shadow: 0px 5px 5px #3d50fa40;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
}
h1 {
  margin-top: 0;
}
.cards {
    display: flex;
    flex-wrap: wrap;
    margin: 15px -5px 30px -5px;
    padding: 10px;
    border: 1px solid #36363a;
}
.card {
    flex-direction: column;
    text-align: center;
    margin: 5px;
    display: flex;
    align-items: flex-start;
    width: calc(25% - 10px);

  .content {
    margin-bottom: 10px;
  }
}
</style>
